<template>
  <div
    id="$address-book$"
    class="width-full height-full bg-F6F6F6 bt address-book"
  >
    <!-- 查看详情 -->
    <div v-if="showSelectDetail" class="width-full height-full fb fb-col">
      <div class="item-flex-1 scroll pt-12 pb-60" refs="scroller">
        <div v-if="(selectedDepts || []).length">
          <p class="font-34 p-16-0 p-0-16">部门</p>
          <div
            v-for="(item, index) in selectedDepts"
            :key="`dept_${index}`"
            class="bg-FFFFFF pl-16"
          >
            <div class="bg-FFFFFF h-68 fb fb-main-start fb-cross-center">
              <div
                class="item-flex-1 height-full fb fb-main-between fb-cross-center"
              >
                <div class="item-flex-1">
                  <span class="font-34 pr-5 max-w-100 text-ellipsis">
                    {{ item.deptName }}
                    <!-- <span class="c-111F2C-40">({{ item.studentCnt }}) </span> -->
                  </span>
                </div>
                <i
                  class="iconfont font-40 c-171A1D-40 mr-16"
                  @click="clearDept(item)"
                  >&#xe670;</i
                >
              </div>
            </div>
          </div>
        </div>
        <div v-if="(selectedMembers || []).length">
          <p class="font-34 p-16-0 p-0-16">人员</p>
          <div
            v-for="(item, index) in selectedMembers"
            :key="`members_${index}`"
            class="bg-FFFFFF pl-16"
          >
            <div class="bg-FFFFFF h-68 fb fb-main-start fb-cross-center">
              <div class="head-img-text fb fb-main-center fb-cross-center">
                {{ nameLastTwoWords(item.userName) }}
              </div>
              <div
                class="item-flex-1 height-full fb fb-main-between fb-cross-center"
              >
                <div class="item-flex-1">
                  <div class="fb fb-col fb-main-center p-9-0">
                    <div class="fb fb-main-start fb-cross-center mb-4">
                      <span class="font-34 pr-5 max-w-100 text-ellipsis">{{
                        item.userName
                      }}</span>
                      <span
                        class="iconfont font-32"
                        :style="{
                          color: +item.gender === 1 ? '#006AFE' : '#ff4d94'
                        }"
                        v-show="item.gender"
                        v-html="SEX_TYPE_ICON[+item.gender]"
                      ></span>
                    </div>
                  </div>
                </div>
                <i
                  class="iconfont font-40 c-171A1D-40 mr-16"
                  @click="clearMember(item)"
                  >&#xe670;</i
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer fixed bottom-0 fb fb-main-center fb-cross-center">
        <common-button @click="clearData" type="add" class="mr-16"
          >清空</common-button
        >
        <common-button type="primary" @click="confirmDetail"
          >确定</common-button
        >
      </div>
    </div>

    <!-- 通讯录页面 -->
    <div v-else class="width-full height-full fb fb-col">
      <!-- 成员搜索输入框 -->
      <common-search-input-box
        class="p-8-0 p-0-8 bg-FFFFFF"
        placeholder="搜索"
        v-if="returnType === 8"
        :delay="1000"
        :searchValue="searchKey"
        @search="handlerToSearchMembers"
      ></common-search-input-box>

      <!-- 部门层级导航 -->
      <common-node-nav
        class="p-0-16"
        v-if="nodeNav.length && !searchKey"
        :nodeNav="nodeNav"
        @click="handlerBackToNode"
      ></common-node-nav>
      <!-- 全选 -->
      <div
        v-show="
          multiple && this.returnType === 7
            ? currentDepts.length
            : currentMembers.length && !searchKey
        "
        class="h-56 fb fb-row fb-start-center font-34 bg-FFFFFF p-0-16 mb-8"
      >
        <common-checkbox :isChecked="isChooseAll" @click="handlerSelectedAll"
          ><span class="ml-12">全选</span></common-checkbox
        >
      </div>
      <div class="item-flex-1 scroll">
        <!-- 搜索结果成员列表 -->
        <div v-show="searchKey" class="node-list h-full font-34">
          <div
            v-show="searchMembers.length === 0"
            class="mt-60 h-full c-171A1D-56 fb-col-center-center item-flex-1"
          >
            <i class="iconfont font-120 c-171A1D-28 mb-16">&#xe6fb;</i>
            <span class="font-26">没有符合搜索条件的记录</span>
          </div>
          <div
            class="fb fb-row fb-cross-center pl-16 bg-FFFFFF"
            @click="handlerChangeMemberSelected(member)"
            v-for="(member, index) in searchMembers"
            :key="index"
          >
            <div class="mr-12"
              ><span
                class="iconfont font-48"
                :class="member.selected ? 'c-006AFE' : 'c-171A1D-24'"
                >{{ member.selected ? '&#xe66e;' : '&#xe66f;' }}</span
              ></div
            >
            <div class="bb item-flex-1 fb fb-row fb-cross-center p-12-0">
              <div class="mr-12 font-24">
                <div
                  class="h-36 w-36 bg-006AFE c-FFFFFF bd-p-50 fb fb-cross-center fb-main-center"
                >
                  {{ nameLastTwoWords(member.userName) }}
                </div>
              </div>
              <div class="item-flex-1">
                <div class="width-full fb fb-cross-center pb-4">
                  <span
                    class="font-34 max-w-180 inline-block text-ellipsis mr-5"
                    >{{ member.userName }}</span
                  >
                  <span
                    class="font-28 iconfont"
                    v-show="member.gender"
                    :style="{
                      color: member.gender === 1 ? '#006AFE' : '#FF4D94'
                    }"
                    >{{ member.gender === 1 ? '&#xe685;' : '&#xe686;' }}</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 子级部门列表、部门成员列表 -->
        <div
          v-show="
            !searchKey &&
            ((currentDepts || []).length || (currentMembers || []).length > 0)
          "
          class="node-list item-flex-1 bg-FFFFFF font-34"
        >
          <!-- 子级部门列表 -->
          <div
            v-for="node in currentDepts"
            class="fb-start-center h-56 lh-56 pl-16"
            :key="node.deptId"
          >
            <span
              v-if="multiple && returnType === 7"
              class="mr-16"
              :class="[
                'iconfont font-48',
                node.selected ? 'c-006AFE' : 'c-171A1D-24'
              ]"
              @click="handlerChangeDeptSelected(node)"
            >
              {{ node.selected ? '&#xe66e;' : '&#xe66f;' }}
            </span>
            <div
              class="bb item-flex-1 fb fb-cross-center fb-main-between pr-16"
            >
              <div
                class="item-flex-1 fb fb-cross-center hidden-x"
                @click="handlerChangeDeptSelected(node)"
                ><span
                  :class="['text-ellipsis inline-block w-adapt-24', 'c-171A1D']"
                  >{{ node.deptName }}
                  <!-- <span class="c-111F2C-40">({{ node.studentCnt }})</span> -->
                </span>
              </div>
              <div class="c-006AFE font-34">
                <span
                  class="bl-12 pl-9"
                  v-if="node.hasChildren || node.type === 5"
                  @click.stop="handlerToGetSubNodes(node)"
                  :class="{ 'c-006AFE-40': node.selected }"
                >
                  <i class="iconfont">&#xe714;</i>下级
                </span>
              </div>
            </div>
          </div>
          <!-- 部门成员列表 -->
          <div
            class="fb fb-row fb-cross-center pl-16"
            @click="handlerChangeMemberSelected(member)"
            v-for="(member, index) in currentMembers"
            :key="index"
          >
            <div class="mr-12"
              ><span
                class="iconfont font-48"
                :class="member.selected ? 'c-006AFE' : 'c-171A1D-24'"
                >{{ member.selected ? '&#xe66e;' : '&#xe66f;' }}</span
              ></div
            >
            <div class="bb item-flex-1 fb fb-row fb-cross-center p-12-0">
              <div class="mr-12 font-32">
                <div
                  class="h-36 w-36 bg-006AFE c-FFFFFF bd-p-50 fb fb-cross-center fb-main-center"
                >
                  {{ nameLastTwoWords(member.userName) }}
                </div>
              </div>
              <div class="item-flex-1">
                <div class="width-full fb fb-cross-center pb-4">
                  <span
                    class="font-34 max-w-180 inline-block text-ellipsis mr-5"
                    >{{ member.userName }}</span
                  >
                  <span
                    class="font-28 iconfont"
                    v-show="member.gender"
                    :style="{
                      color: member.gender === 1 ? '#006AFE' : '#FF4D94'
                    }"
                    >{{ member.gender === 1 ? '&#xe685;' : '&#xe686;' }}</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 非搜索的时候没有数据 -->
        <div
          v-show="!currentDepts.length && !searchKey && returnType === 7"
          class="h-full c-171A1D-56 fb-col-center-center item-flex-1 icon-no-data-box"
        >
          <div class="icon-no-data"></div>
          <span class="font-34">暂无部门</span>
        </div>
      </div>
      <div
        class="font-26 fb fb-cross-center fb-main-between h-60 bg-FFFFFF p-0-16 bt-8"
      >
        <div
          class="item-flex-1 c-006AFE text-ellipsis"
          @click.stop="handlerViewDetail"
        >
          {{ computedSelectedText }}
        </div>
        <div>
          <common-button
            type="primary"
            :styles="'font-24'"
            width="95"
            height="32"
            @click="handlerToSubmit"
            >确定</common-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import API from '@/api/addressbook'
import store from '@/store'
import {
  commonSearchInputBox,
  commonNodeNav,
  commonButton,
  commonCheckbox
} from '@/components/commonAddressBook'
import {
  getItem,
  nameLastTwoWords,
  setLeft,
  removeLeft,
  pushNullUrl
} from '@/utils/comUtils'
import {
  mcConfirm,
  mcShowPreloader,
  mcHidePreloader,
  mcToast,
  mcSetTitle
} from '@/utils/mcSdkUtils'

import { SEX_TYPE_ICON } from '@/utils/constUtils'

export default {
  components: {
    commonSearchInputBox,
    commonNodeNav,
    commonButton,
    commonCheckbox
  },
  props: {},
  data() {
    return {
      SEX_TYPE_ICON,
      nameLastTwoWords,
      // =================================================================
      rootDeptId: '',
      postData: {
        campusId:
          getItem('currentCapmusId') ||
          (store.getters.currentCapmus || {}).tpId ||
          '',
        currentRole: '3',
        sandboxType: 4
      },
      selectedMembers: [], // 已选人员列表
      selectedDepts: [], // 已选部门列表
      // =================================================================
      nodeNav: [], // 导航栏部门节点对象数组
      currentDepts: [], // 当前展示部门节点列表
      currentMembers: [], // 当前展示成员节点列表
      // 成员搜索相关
      searchKey: '', // 搜索人员姓名关键字
      searchMembers: [], // 当前搜索人员姓名列表
      showSelectDetail: false, // 展示选择详情
      sandboxStatus: 1, // 1 正在初始化 2 沙箱已准备好 3 正在增加选项 4 正在清除选项 5 重置中（暂无此状态） 6 提交中 7 已坏掉（处理数据异常） 8 已关闭
      sandboxItvl: null, // 查询状态定时器
      parentTpId: '', // 父节点id
      parentDeptId: '', // 父节点id
      pageNum: 50, // 分页页码
      pageSize: 9999, // 查询部门下面的人
      clicking: false,
      clearConfirm: null
    }
  },
  computed: {
    computedSelectedText() {
      // 7: 部门 8: 成员
      let _result = ''
      if (this.returnType === 7) {
        _result = `已选择: ${this.selectedDepts.length} 部门`
      } else {
        _result = `已选择: ${this.selectedMembers.length} 人`
      }
      return _result
    },
    isChooseAll() {
      return !(
        this.returnType === 7 ? this.currentDepts : this.currentMembers
      ).find(v => !v.selected)
    }
  },
  watch: {},
  beforeCreate() {},
  created() {
    pushNullUrl()
    setLeft(this.methodSetLeft)
    if ((this.propSelectedDepts || []).length && this.returnType === 7) {
      this.selectedDepts = this.propSelectedDepts
    }
    if ((this.propSelectedMembers || []).length && this.returnType === 8) {
      this.selectedMembers = this.propSelectedMembers.map(v => {
        return {
          userId: v.memberId,
          userName: v.memberName
        }
      })
    }
  },
  beforeMount() {},
  mounted() {
    if (this.title) {
      mcSetTitle(this.title)
    }
    // 钉钉回退按钮监听拦截
    this.init()
  },
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {
    clearInterval(this.sandboxItvl)
    removeLeft(this.methodSetLeft)
  },
  destroyed() {},
  methods: {
    //  初始化
    async init() {
      if (!this.sandboxId) {
        await this.addressCreate()
      }
      await this.getSandboxStatus()
      await this.addressGetNodes(true)
      this.methodInitNodeNav()
    },
    // 初始化数据
    initData() {
      this.parentTpId = '' // 父节点id
      this.parentDeptId = '' // 父节点id
      this.searchKey = ''
      this.searchMembers = []
    },
    // 搜索人员姓名
    async handlerToSearchMembers(searchKey) {
      this.searchKey = searchKey
      if (!searchKey) {
        this.addressGetNodes()
        return
      }
      this.fetchMembersByKey()
    },
    // 获取子部门/人员
    async handlerToGetSubNodes(node) {
      if (this.clicking || node.selected) {
        return
      }
      this.clicking = true
      this.methodUpdateNodeNav(node)
      this.parentTpId = node.deptTpId
      this.parentDeptId = node.deptId
      await this.addressGetNodes()
      this.clicking = false
    },
    // 切换部门勾选状态
    async handlerChangeDeptSelected(node) {
      let active = this.selectedDepts.findIndex(v => v.deptId === node.deptId)
      if (node.selected) {
        if (active !== -1) {
          this.selectedDepts.splice(active, 1)
        }
      } else {
        this.selectedDepts.push(node)
      }
      node.selected = !node.selected
      this.$forceUpdate()
    },
    // 切换人员节点勾选状态
    handlerChangeMemberSelected(node) {
      let active = (
        this.searchKey && this.searchMembers.length
          ? this.searchMembers
          : this.selectedMembers
      ).findIndex(v => v.userId === node.userId)
      if (node.selected) {
        if (active !== -1) {
          this.selectedMembers.splice(active, 1)
        }
      } else {
        this.selectedMembers.push(node)
      }
      node.selected = !node.selected
      this.$forceUpdate()
    },
    // 全选操作--搜索隐藏全选
    async handlerSelectedAll() {
      let status = !!(
        this.returnType === 7 ? this.currentDepts : this.currentMembers
      ).find(v => !v.selected)

      // target 当前
      if (this.returnType === 7) {
        this.currentDepts.forEach(item => {
          if (item.selected !== status) {
            this.handlerChangeDeptSelected(item)
          }
        })
      } else {
        this.currentMembers.forEach(item => {
          if (item.selected !== status) {
            this.handlerChangeMemberSelected(item)
          }
        })
      }
    },
    // 查看已选人员
    async handlerViewDetail() {
      this.showSelectDetail = true
    },
    // 删除已选人员
    async clearMember(node) {
      this.selectedMembers.splice(
        this.selectedMembers.findIndex(v => v.userId === node.userId),
        1
      )
      this.currentMembers.forEach(v => {
        if (v.userId === node.userId) {
          v.selected = false
        }
      })
      this.$forceUpdate()
    },
    // 删除已选部门
    async clearDept(node) {
      this.selectedDepts.splice(
        this.selectedDepts.findIndex(v => v.deptId === node.deptId),
        1
      )
      this.currentDepts.forEach(v => {
        if (v.deptId === node.deptId) {
          v.selected = false
        }
      })
      this.$forceUpdate()
    },
    // 查看已选-确认
    async confirmDetail() {
      this.showSelectDetail = false
    },
    // 查看已选-清空
    clearData() {
      const that = this
      let ids = that.selectedDepts.map(v => v.deptId)
      let userIds = that.selectedMembers.map(v => v.userId)
      this.clearConfirm = this.$Dialog({
        type: 'confirm',
        title: '提示',
        content: `确认清空已选成员`,
        onConfirm() {
          that.currentDepts.forEach(v => {
            if (ids.includes(v.deptId)) {
              v.selected = false
            }
          })
          that.currentMembers.forEach(v => {
            if (userIds.includes(v.userId)) {
              v.selected = false
            }
          })
          that.selectedDepts = []
          that.selectedMembers = []
          that.$forceUpdate()
        }
      }).show()
    },
    // 初始化导航栏
    methodInitNodeNav({ name, deptId = '' } = {}) {
      this.nodeNav = [
        {
          deptName: name || '通讯录',
          deptId: deptId,
          type: 0
        }
      ]
    },
    // 更新导航栏
    methodUpdateNodeNav(node, isAdd = true) {
      if (isAdd) {
        this.nodeNav.push(node)
      } else {
        let _index = this.nodeNav.findIndex(item => item.deptId === node.deptId)
        this.nodeNav = this.nodeNav.slice(0, _index + 1)
      }
    },
    // 返回导航栏
    async handlerBackToNode(node) {
      this.methodUpdateNodeNav(node, false)
      this.parentTpId = node.deptTpId
      this.parentDeptId = node.deptId
      this.addressGetNodes()
    },
    // 点击确认 关闭选人组件
    async handlerToSubmit() {
      if (this.clicking) {
        return
      }
      this.clicking = true
      // 7: 部门 8: 人员
      this.close(
        this.returnType === 7 ? this.selectedDepts : this.selectedMembers
      )
    },
    // 回退拦截
    methodSetLeft() {
      pushNullUrl()
      if (this.showSelectDetail) {
        this.clearConfirm && this.clearConfirm.hide()
        this.showSelectDetail = false
      } else {
        if (this.showConfirm) {
          return false
        }
        this.showConfirm = true
        mcConfirm({ msg: '确认退出此操作吗?', closeOnPopstate: false })
          .then(async btnIndex => {
            if (btnIndex === 1) {
              mcHidePreloader()
              this.closeOnly()
            } else {
              this.showConfirm = false
            }
          })
          .catch(err => {
            console.log('unhandledrejection', err)
          })
      }
    },
    // 创建选人组件沙盒API
    addressCreate() {
      return new Promise((resolve, reject) => {
        API.createOrgSandBox({
          ...this.postData,
          calDeptAllMemberCnt: true
        })
          .then(res => {
            if (res && res.result && res.result !== '0') {
              return false
            }
            if (res) {
              store.commit('orgSandboxId', res)
              this.sandboxId = res
            }
            resolve(res)
          })
          .catch(err => {
            console.log(err)
            reject(err)
          })
      })
    },
    // 轮训查状态API
    getSandboxStatus() {
      // 1 正在初始化 2 沙箱已准备好 3 正在增加选项 4 正在清除选项 5 重置中（暂无此状态） 6 提交中 7 提交失败，待重试 8 已坏掉
      this.sandboxStatus = 1
      let _itvlTimes = 0
      mcShowPreloader()
      clearInterval(this.sandboxItvl)
      return new Promise((resolve, reject) => {
        if (this.isSandboxComplete) {
          resolve(true)
        } else {
          this.sandboxItvl = setInterval(async () => {
            ++_itvlTimes
            if (_itvlTimes >= 20) {
              clearInterval(this.sandboxItvl)
              this.addressResetStatus()
              mcHidePreloader()
              mcToast({ msg: '操作超时，请重试～' })
            }
            switch (this.sandboxStatus) {
              case 2:
                this.isSandboxComplete = true
                clearInterval(this.sandboxItvl)
                resolve(this.sandboxStatus)
                break
              case 8:
                clearInterval(this.sandboxItvl)
                this.addressResetStatus()
                mcHidePreloader()
                mcToast({ msg: '操作超时，请重试～' })
                this.initData()
                this.init()
                break
              default:
                await this.addressGetStatus()
                break
            }
          }, 1000)
        }
      })
    },
    // 查询树准备情况API
    addressGetStatus() {
      return new Promise((resolve, reject) => {
        API.getOrgSandBoxStatus({
          ...this.postData,
          calcMemberSelCnt: true,
          sandboxId: this.sandboxId
        })
          .then(res => {
            this.sandboxStatus = res.sandboxStatus || 0
            resolve(res)
          })
          .catch(err => {
            console.log(err)
          })
      })
    },

    // 查树节点信息API
    addressGetNodes(init) {
      return new Promise(async (resolve, reject) => {
        this.currentDepts = []
        this.currentMembers = []
        this.fetchHandler('getOrgSubNodes', {
          parentDeptId: this.parentDeptId || null
        })
          .then(res => {
            // type 校区: 0 学段: 1 年级: 2 班级: 3 部门: 4
            if (init) {
              this.rootDeptId = (this.currentDepts[0] || {}).deptId || ''
            }
            // 处理外层传入的回显数据, 以及处理当前选中的数据
            res.forEach(item => {
              let activeIndex = this.selectedDepts.findIndex(
                v => v.deptId === item.deptId
              )
              item.selected = activeIndex !== -1
              if (
                activeIndex !== -1 &&
                !this.selectedDepts[activeIndex]?.deptTpId
              ) {
                this.selectedDepts[activeIndex] = {
                  ...item
                }
              }
            })
            this.currentDepts = res
            mcHidePreloader()
            resolve(res)
          })
          .catch(err => {
            mcHidePreloader()
            console.log(err)
          })
        if (this.parentDeptId && this.returnType === 8) {
          const res = await this.fetchHandler('getOrgDeptUsers', {
            deptId: this.parentDeptId
          })
          // 处理外层传入的回显数据, 以及处理当前选中的数据
          ;(res || []).forEach(item => {
            let activeIndex = this.selectedMembers.findIndex(
              v => v.userId === item.userId
            )
            item.selected = activeIndex !== -1
            // 处理外层传入的回显数据
            if (
              activeIndex !== -1 &&
              !this.selectedMembers[activeIndex]?.userTpId
            ) {
              this.selectedMembers[activeIndex] = {
                ...item
              }
            }
          })
          this.currentMembers = res || []
        }
      })
    },
    // 搜索人员API
    fetchMembersByKey() {
      return new Promise((resolve, reject) => {
        let API_URL = 'searchOrgUsers'
        let requestData = { limit: 50, q: this.searchKey }
        this.fetchHandler(API_URL, requestData)
          .then(res => {
            ;(res || []).forEach(item => {
              let activeIndex = this.selectedMembers.findIndex(
                v => v.userId === item.userId
              )
              item.selected = activeIndex !== -1
              // 处理外层传入的回显数据
              if (
                activeIndex !== -1 &&
                !this.selectedMembers[activeIndex]?.userId
              ) {
                this.selectedMembers[activeIndex] = {
                  ...item
                }
              }
            })
            this.searchMembers = res || []
          })
          .catch(err => {
            console.log('unhandledrejection', err)
          })
      })
    },
    // 重置沙箱
    async addressResetStatus() {
      await this.fetchHandler('resetOrgSandBox')
    },
    // 销毁沙箱
    async addressRollback() {
      await this.fetchHandler('rollbackOrgSandBox')
    },
    // 通用api
    fetchHandler(apiUrl, param = {}) {
      return new Promise((resolve, reject) => {
        API[apiUrl]({ ...this.postData, sandboxId: this.sandboxId, ...param })
          .then(res => {
            mcHidePreloader()
            if ((res && res.result && res.result !== '0') || res === null) {
              return false
            }
            resolve(res)
          })
          .catch(err => {
            console.log(err)
            mcHidePreloader()
          })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.address-book {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 22;
  overflow-y: scroll;
}
.icon-no-data {
  width: 70px;
  height: 70px;
  background: url('~@/assets/images/staying-student.png');
  background-size: cover;
}

.node-list {
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
}

.tab-bottom {
  position: absolute;
  bottom: 0;
  left: 50%;
  margin-left: -12px;
  width: 24px;
  height: 3px;
  background: #006afe;
  border-radius: 2px;
}
.head-img-text {
  height: 36px;
  width: 36px;
  color: #ffffff;
  margin-right: 12px;
  background: #006afe;
  border-radius: 50%;
}
.footer {
  :deep(.c-button) {
    height: 46px;
    line-height: 46px;
    border-radius: 8px;
  }
}
</style>
